<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 16:59:52
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 01:07:29
-->
<template>
  <div class="record-detail-page page-container">
    <video-player
      :datas="videoData"
      :speaker="speaker"
      :allowEvent.sync="playerAllowEvent"
      :collect="miniTabActive[HEART_ID]"
      @clickCollect="onClickMiniTab(HEART_ID)"
    ></video-player>
    <div class="content">
      <div class="container-wrap">
        <div class="left-bl clearfix">
          <transition name="el-fade-in-linear">
            <div class="child-bl" v-html="draft" v-show="miniTabActive[DOC_ID]"></div>
          </transition>
          <transition name="el-fade-in-linear">
            <comment-list
              class="child-bl"
              :topic="topic"
              type="record"
              :id="recordId"
              v-show="!miniTabActive[DOC_ID]"
              @inputFocus="inputFocus"
            ></comment-list>
          </transition>
        </div>
        <div class="right-bl">
          <mini-tabs @onClickTab="onClickMiniTab" :active="miniTabActive"></mini-tabs>
          <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import RecommendVideos from '@/components/AppRecommendVideos';
import MiniTabs from '@/components/AppMiniTabs';
import CommentList from '@/components/AppCommentList';
import requestApi from '@/service';

import configFields from '@/utils/configFields';
const { DOC_ID, HEART_ID, DRAFT_TYPE } = configFields;
export default {
  name: 'RecordDetail',
  components: {
    VideoPlayer,
    RecommendVideos,
    MiniTabs,
    CommentList,
  },
  data() {
    return {
      videoData: {},
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      speaker: {},
      recommendList: [],
      topic: {},
      comments: [
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
        {
          user: {
            avatar: 'https://cdn.yixi.tv/almond/15943931239036.jpg?imageView2/1/w/40/h/40',
            name: '玉小赤',
          },
          praise: '44',
          content: '"我们一直有一个信念，公益不是一两个人的倾家荡产，而是很多人的力所能及。“这句话好棒',
          date: '2020/07/10',
        },
      ],
      commentsTotal: 2,
      DOC_ID,
      HEART_ID,
      miniTabActive: {},
      draft: '',
      recordId: null,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/record/detail') {
        this.init();
      }
    },
  },
  methods: {
    init() {
      Object.assign(this.$data, this.$options.data());
      this.recordId = this.$route.query.id;
      this.miniTabActive = {
        [DOC_ID]: false,
        [HEART_ID]: false,
      };
      this.getData();
      this.getRecommend();
      this.initScrollTop();
    },
    getData() {
      requestApi(`/api/site/record/${this.recordId}/detail/`).then(({ record }) => {
        const { speaker, cover, video_url, title, city, date, titlelanguage, is_collect } = record;
        this.videoData = {
          cover,
          videoUrls: video_url,
          intro: titlelanguage,
        };
        this.miniTabActive[HEART_ID] = is_collect;
        this.speaker = speaker;
        this.topic = {
          title,
          city,
          date,
          intro: titlelanguage,
        };
      });
    },
    getRecommend() {
      const url = `/api/site/record/${this.recordId}/recommend/`;
      requestApi(url).then(({ recommended }) => {
        this.recommendList = recommended && recommended.length ? recommended : [];
      });
    },
    onClickMiniTab(id) {
      if (id === DOC_ID) {
        if (!this.draft) {
          this.getDarft().then(res => {
            if (res) {
              this.miniTabActive[id] = !this.miniTabActive[id];
            }
          });
        } else {
          this.miniTabActive[id] = !this.miniTabActive[id];
        }
      } else if (id === HEART_ID) {
        if (this.checkLogin()) {
          this.collect().then(() => {
            this.miniTabActive[id] = !this.miniTabActive[id];
          });
        }
      }
    },
    collect() {
      return requestApi(
        '/api/v1/record/collection/change/',
        {
          record_id: this.recordId,
        },
        'POST'
      );
    },
    /**
     * @description: 获取演讲稿
     */
    getDarft() {
      return new Promise(resolve => {
        requestApi('/api/site/draft/', {
          id: this.recordId,
          type: DRAFT_TYPE.record,
        }).then(({ draft }) => {
          if (draft) {
            this.draft = draft;
            resolve(true);
          } else {
            this.$message.error('未找到文稿');
            resolve(false);
          }
        });
      });
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
    onClickRecommend(id) {
      this.$router.push({
        path: '/record/detail',
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.video-actions-bl {
  position: relative;
  width: 100%;
  text-align: center;
}
.content {
  .container-wrap {
    display: flex;
    align-items: flex-start;
    margin: 20px auto 100px;
  }
  .left-bl {
    width: 72%;
    max-width: 827px;
    margin-right: 10px;
    box-sizing: border-box;
    background: $C1;
    padding: 20px;
  }
  .right-bl {
    width: 28%;
    background-color: $C10;
  }
}
</style>
